module.exports = __webpack_public_path__ + "img/plan-silver-plus.6b07cea9.svg";